// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--XEX6D","flex":"flex--fYCIK","button":"button--wZl9G","icon":"icon--Ii0V4","title":"title--eVKI6"};